// This file deals with entering an assessment without an access hash,
// by way of a validation token.

import {
  zip,
} from 'rxjs';

import {
  map,
  take,
} from 'rxjs/operators';

import { Operators } from 'rsm';
const { postAjax } = Operators;

import { jwtDecode } from './JWTDecode';



// IMPLICIT DEPENDENCIES:
//
// - Routes
// - MCApi.checkQuestions
//
// TODO: refactor these into static imports



// Takes as argument the validation token. Returns a Promise that
// resolves to an object of the form:
//
//     { testItems: (...), testParams: (...), studentNumber: "..." }
//
export const loadAssessment = tok => new Promise(( resolve, reject ) => {
  const validation = jwtDecode(tok);
  const studentNumber = validation.student_number;  // may be undefined

  const loggingIn = zip( getQuestions$(tok), checkStudent$(tok) ).pipe(
    take(1),
    map(([ { testItems, parts, scorableQuestions }, testParams ]) => (
      { testItems, parts, scorableQuestions, testParams, studentNumber })),
  );

  // Trivially map observable onto the surrounding promise
  loggingIn.subscribe({ next: resolve, error: reject });
});



const getQuestions$ = tok => postAjax({
  url: Routes.getQuestionsURL(undefined, 5),
  body: { validation: tok },

}).pipe(
  map(({ response }) => {
    const { success, parts } = response

    if (!success)
      throw 'access denied'

    return {
      parts,
      ...extractItems(response)
    }
  }),
);



const checkStudent$ = (tok, lockPartId, sequenceNumber) => postAjax({
  url: Routes.checkStudentURL(undefined, undefined, 5, LegacyShims.getCookie('rldbrv'), LegacyShims.getCookie('rldbci')),
  body: {
    lock_part_id: lockPartId,
    lock_id: sequenceNumber,
    validation: tok,
    domain: document.location.hostname
  },
  withCredentials: true
}).pipe(
  map(({ response }) => {
    const { items } = response
    let itemInfo = {}

    if (items?.success) {
      itemInfo = extractItems(items)
    }

    return {
      ...response,
      ...itemInfo
    }
  }),
);


export const checkStudent = (tok, lockPartId, sequenceNumber) => new Promise(( resolve, reject ) => (
  checkStudent$(tok, lockPartId, sequenceNumber)
    .subscribe({ next: resolve, error: reject })
))


const extractItems = ({ items, scorable_questions, x, y }) => {
  if (y) {
    return { testItems: JSON.parse( new MCApi().checkQuestions(x, y) )}

  } else if (items) {
    return { testItems: items, scorableQuestions: scorable_questions }

  } else {
    throw 'access denied'
  }
}
